import { useContext } from 'react';
import PropTypes from 'prop-types';

import { FormStepContext } from '../stages/FormStepContext';

const ButtonBack = ({ stepId }) => {
  const { setStep } = useContext(FormStepContext);

  const onSetPrevStep = () => {
    setStep(stepId - 1);
  };

  return (
    <button
      type="button"
      className="secondaryFatLink ic-arrow-right"
      onClick={onSetPrevStep}
    >
      Back
    </button>
  );
};

export default ButtonBack;

ButtonBack.propTypes = {
  stepId: PropTypes.number.isRequired,
};
